module.exports = __webpack_public_path__ + "img/img-testimonios.b6a9dceb.webp";